import Vue from 'vue'
import axios from 'axios'
import router from '../router'
import qs from 'qs'
import store from '@/store'
import { getAccessToken } from '@/utils/auth'
import { AUTH_TYPES } from '@/store/modules/auth'
import { ERROR_TYPES } from '../store/modules/error'

const defaultOptions = {
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'content-type': 'application/json; charset=utf-8',
    'Accept': 'application/json'
  },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
}

/*
  This handler is set up as an interceptor below, so it will handle any http errors.
  To disable this global error handler and handle the error at the component level,
  just specify handleError: false in your request config
  ex. axios.get('/user/1', {handleError: false})
 */
function errorResponseHandler (error) {
  if (Object.prototype.hasOwnProperty.call(error.config, 'handleError') && error.config.handleError === false) {
    return Promise.reject(error)
  }
  handleError(error)
}

export const handleError = (error) => {
  if (error.response) {
    const code = parseInt(error.response && error.response.status)
    if (code === 401) {
      store.dispatch(AUTH_TYPES.actions.trySetAccessToken, false)
        .then(
          () => axios.request(error.config),
          (err) => {
            console.log(err)
            if (err && err.includes('user_login_error')) {
              store.dispatch(AUTH_TYPES.actions.b2cSignIn)
            } else {
              store.dispatch(AUTH_TYPES.actions.clearSession)
            }
          }
        ).catch(err => console.log(err))
    } else {
      console.error(JSON.stringify(error))
      if (error.response.data && error.response.data.isUserFriendly) {
        error.message = error.response.data.message
      } else {
        error.message = `${error.message} | url: ${error.config.url} | method: ${error.config.method}`
      }
      store.dispatch(ERROR_TYPES.actions.setError, error)
      if (router.currentRoute.path !== '/error') {
        router.push('/error')
      }
    }
  }
}

export const http = (token = null) => {
  // Create instance
  let instance = axios.create(defaultOptions)

  const tenantId = store.state.auth?.currentTenantId

  // Set the AUTH token for any request
  instance.interceptors.request.use(function (config) {
    const storedToken = getAccessToken()

    config.headers.Authorization = `Bearer ${token || storedToken}`
    config.headers = {
      ...config.headers,
      'x-bpg-tenant-id': tenantId
    }

    return config
  })

  instance.interceptors.response.use(
    response => response ? response.data : response, // Map response to data by default
    errorResponseHandler // Set a global error handler for each response
  )

  Vue.prototype.$http = instance

  return instance
}

export default http
